import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import { ReactComponent as Close } from "../../components/ui/styles/Icon_Close.svg";
import { ReactComponent as EditIcon } from "../../components/ui/styles/Icon_Edit.svg";

import Modal from "../../components/ui/Modal";
import styled from "styled-components";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addDomain, updateDomain } from "../../redux/features/PlatformSettingSlice";
import { ToggleButton } from "@mui/material";

export const ModalCard = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 12%);
  // overflow: hidden;
  width: 750px;
`;

export const ModalCardBody = styled.div`
  padding: 22px;
  margin: 0;
  list-style-type: none;
  background: #fff;
  ul {
    padding: 0;
    list-style-type: none;
    text-align: left;
    margin: 10px 0;
    li {
      font-size: 14px;
      font-weight: 400;
      color: #999;
      line-height: 20px;
      span {
        font-weight: 700;
      }
    }
  }
`;

export const ModalCardHead = styled.div`
  border-bottom: 1px solid #ed8154;
  background: #ed8154;
  padding: 8px 22px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;

  h6 {
    font-size: 16px !important;
    color: #fff !important;
    margin: 0;
    font-weight: 600;
  }
  button {
    padding: 0;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ModalCardForm = styled.div`
  width: 100%;
  input {
    width: 100%;
    border: 1px solid #ddd;
    min-height: 40px;
    box-sizing: border-box;
    padding: 8px 12px;
    border-radius: 8px;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  label {
    font-size: 14px !important;
    color: #666 !important;
    margin: 0;
    width: 100%;
    text-align: left;
    display: block;
    margin-bottom: 6px;
    font-weight: 700;
  }
`;

export const InputBox = styled.div`
  margin-bottom: 20px;
  & > div > div {
    border-color: #ddd;
  }
`;

export const ModalCardButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 22px;

  button {
    font-size: 14px;
    color: #fff;
    background: #ed8154;
    border: 1px solid #ed8154;
    border-radius: 8px;
    overflow: hidden;
    padding: 8px 20px;
    min-width: 95px;
    margin-left: 12px;
    font-weight: 600;
    &:first-of-type {
      margin-left: 0;
      background: #fff;
      color: #ed8154;
    }
  }
`;


const CheckBox = styled.div`
    text-align: left;
    input {
        display: none;
    }
    label {
        font-size: 14px !important;
        color: #666 !important;
        margin: 0;
        width: 100%;
        text-align: left;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:before {
            content: "";
            height: 15px;
            width: 15px;
            border: 1px solid #bdbdbd;
            border-radius: 3px;
            background: #fff;
            display: inline-block;
            margin-right: 12px;
            flex-grow: 0;
            flex-shrink: 0;
            flex-basis: 15px;
        }
        &:after {
            content: "";
            height: 5px;
            width: 9px;
            border-left: 2px solid #fff;
            border-bottom: 2px solid #fff;
            position: absolute;
            left: 4px;
            transform: rotate(-45deg);
            margin-bottom: 4px;
        }
    }
    input:checked + label:before {
        background: #ed8154;
        border: 2px solid #ed8154;
    }
`;


export const TableActionBtn = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    span {
        background: #fff;
        height: 20px;
        width: 20px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
            height: 16px !important;
            width: 16px !important;
            path {
                fill: #ed8154;
            }
        }

        &.large-btn {
            height: 40px;
            width: 40px;
            svg {
                height: 20px !important;
                width: 20px !important;
            }
        }
    }
`;

const domainReg = /^(?=.{1,253}$)(?!\-)(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

const UpdateDomainModal = ({ domain: obj }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [domain, setDomain] = useState(obj.domain);
    const [active, setActive] = useState(obj.active);

    const domainNameError = domain && !domainReg.test(domain.trim());

    const close = () => setOpen(false);
    const add = () => {
        dispatch(updateDomain({ id: obj._id, data: { domain, active } }));
        close();
    };

    return (
        <>

            <TableActionBtn>
                <span
                    onClick={() => setOpen(true)}
                >
                    <EditIcon />
                </span>
            </TableActionBtn>
            <Modal show={open} >
                <ModalCard>
                    <ModalCardHead>
                        <h6>Update domain</h6>
                        <div style={{ cursor: 'pointer', padding: 10 }} onClick={close}>

                            <Close />
                        </div>
                    </ModalCardHead>
                    <ModalCardBody>
                        <ModalCardForm>
                            <InputBox>
                                <label>Domain</label>
                                <Input
                                    value={domain}
                                    onChange={(e) => setDomain(e.target.value)}
                                    style={domainNameError ? {
                                        border: '1px solid #C93E3E'
                                    } : {}}
                                    placeholder="Enter domain (e.g. qone-tech.com)"
                                />
                            </InputBox>
                            <CheckBox>
                                <input
                                    type="checkbox"
                                    value={active}
                                    checked={active}
                                    id={obj._id}
                                    onChange={(e) => setActive(e.target.value !== 'true')}
                                />
                                <label
                                    htmlFor={
                                        obj._id
                                    }
                                >
                                    Domain active
                                </label>
                            </CheckBox>

                        </ModalCardForm>
                        <ModalCardButtons>
                            <Button onClick={close}>
                                Close
                            </Button>
                            <Button
                                disabled={domainNameError}
                                id="b-login"
                                onClick={add}
                            >
                                Save
                            </Button>
                        </ModalCardButtons>
                    </ModalCardBody>
                </ModalCard>
            </Modal>


        </>

    )
}

export default UpdateDomainModal;